import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {AiCreditService} from '@services/ai-credit.service';
import {User} from '@models/user';
import {UserService} from '@services/user.service';
import {TrackingService} from '@services/tracking.service';
import {EMPTY_FAVORITE_LIST} from '@models/empty';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {MatMenuTrigger} from '@angular/material/menu';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    // Popups mobiles du header : le contenu (pictoList desktop) n'utilise pas
    // mat-menu-item, on ferme donc le menu quand un lien ou une action est cliqué
    // (sinon il reste ouvert par-dessus la page de destination) ; un clic dans le
    // vide ne ferme pas (stopPropagation).
    closeMenuOnAction(event: Event, trigger: MatMenuTrigger) {
        if ((event.target as HTMLElement).closest('a, button')) {
            trigger.closeMenu();
        } else {
            event.stopPropagation();
        }
    }


    @Output() toggle: EventEmitter<null> = new EventEmitter();

    user: User;
    returnUrl: string;
    url_plan = '/app/user/plan';
    stripe = Stripe(environment.stripeKey);
    expired_card = false;
    showPromo = true;
    trialDay = 5;
    promoDelay: number[];

    // end = new Date('2021-11-07 23:59:59');
    // now = new Date();
    //
    // config: CountdownConfig = {
    //     leftTime: (this.end.getTime() - this.now.getTime()) / 1000,
    //     formatDate: ({ date, formatStr }) => {
    //         const seconds = Number(date / 1000 || 0);
    //
    //         const d = Math.floor(seconds / (3600 * 24));
    //         const h = Math.floor(seconds % (3600 * 24) / 3600);
    //         const m = Math.floor(seconds % 3600 / 60);
    //         const s = Math.floor(seconds % 60);
    //
    //         return 'L\'offre se termine dans : ' + (d > 0 ? d + (d === 1 ? ' jour ' : ' jours ') : '') + h + (h === 1 ? ' heures ' : ' heures ') + m + (m === 1 ? ' minute et ' : ' minutes et ') + s + (s === 1 ? ' secondes ' : ' secondes');
    //     },
    // };

    constructor(
        private router: Router,
        private userService: UserService,
        public trackingService: TrackingService,
        private http: HttpClient,
        public authenticationService: AuthenticationService,
        public aiCreditService: AiCreditService
    ) {
    }

    // Bandeau « mail non éligible à l'essai » : seulement sans plan et sur un compte de moins de 15 jours.
    get showBadEmail(): boolean {
        const user = this.authenticationService.currentUser;
        const accountDays = (new Date().getTime() - new Date(user.created_at).getTime()) / 86400000;
        return user.exclude == true && user.pro_plan == '' && user.plan == '' && accountDays <= 15;
    }

    ngOnInit() {
        this.user = this.authenticationService.currentUser;
        this.returnUrl = this.router.url;
        // Les comptes internes LyBox (pro_plan = lybox) ont un abonnement classique,
        // pas une offre pro : ils gèrent leur abonnement sur /app/user/plan.
        if (this.user.pro_plan != '' && this.user.pro_plan != 'lybox') {
            this.url_plan = '/app/user/plan-pro';
        } else if (this.user.plan != '' && this.user.plan != 'trial' && this.user.plan != 'trial_plus') {
            this.url_plan = '/app/user/plan';
        } else {
            var domains = ['monchasseurimmo',
                'investissement-locatif',
                'kwfrance',
                'iadfrance',
                'projetlocatif',
                'efficity',
                'oikos-immo',
                'izimmo',
                'livecolonies',
                'masteos',
                'citya',
                'orpi',
                'projetrentable',
                'myvesta',
                'alpesvente',
                'nouvelle-demeure',
                'lesagencesdepapa',
                'immocitiz',
                'prudenzia-immobilier',
                'promethee-immo',
                'serial-immo',
                '110chasseimmobiliere',
                'elixiumpatrimoine',
                'nestenn',
                'human-immobilier',
                'stephaneplazaimmobilier',
                'globalimmofrance',
                'lesarchitectesdupatrimoine',
                'capifrance',
                'horizon-invest',
                'bevouac',
                'smart-investissement',
                'ozeoimmo',
                'louveinvest',
                'laforet',
                'essonne-patrimoine',
                'welmo',
                'safti',
                'duflotimmobilier',
                'proprietes-privees',
                'oli-investissements',
                'guyhoquet',
                'guy-hoquet',
                'cedricberthelon',
                'find-my-home',
                'optimhome',
                'am-capital',
                'hevrest',
                'macompagnieimmobiliere',
                'immomaispasque',
                'meilleursagents',
                'coach-immo',
                'investirdanslancien',
                'berche',
                'reseau-icm',
                'evermind',
                'lbpconseil',
                'corporateimmo',
                'immobiliercapital',
                'invest-preneur',
                'bskimmobilier',
                'eightcorp',
                'ataraxiapatrimoine',
                'prisme-agency',
                'lecoindulmnp',
                'bakarra-immobilier',
            ];
            domains.forEach((s, i) => {
                if (this.user.email.includes('@' + s)) {
                    this.url_plan = '/app/user/plan-pro';
                }
            });
        }

        if (this.user.pro_plan != '' || (this.user.plan != '' && this.user.plan != 'trial' && this.user.plan != 'trial_plus')) {
            if (this.user.payment_method.type == 'card') {
                var currentMonth = (new Date().getFullYear()) * 12 + (new Date().getMonth()) + 1;
                var cardMonth = this.user.payment_method.exp_year * 12 + this.user.payment_method.exp_month;

                let subscriptionEndDate = new Date(this.user.subscription.current_period_end).getTime();
                let days = (subscriptionEndDate - new Date().getTime()) / 86400000;
                if (currentMonth >= cardMonth - 3 && days < 90) {
                    this.expired_card = true;
                }
            }
        }

        this.trialDay = this.authenticationService.getTrialDay()
        if (this.user.plan == "trial_plus") {
            this.trialDay = this.authenticationService.getTrialPlusDay()
        }
        this.showPromo = this.authenticationService.showPromo();

        let diff = new Date(this.authenticationService.currentUser.promo_end_date).getTime() - new Date().getTime()
        let min = Math.round(diff / 1000 / 60)
        this.promoDelay = [Math.floor(min / (60 * 24)), Math.floor((min % (60 * 24)) / 60), min % 60]
    }

    logout() {
        this.authenticationService.logout();
        this.router.navigate(['/app/login']);
    }

    openOnboarding() {
        this.authenticationService.currentUser.user_onboarding.open = true;
        this.authenticationService.currentUser.user_onboarding.dismiss = false;
        this.userService.updateOnboarding(this.authenticationService.currentUser);
    }

    updateCB() {
        this.http.post<any>(`${environment.apiUrl}app/paiement/create-update-checkout-session`, {}).subscribe(
            session => {

                this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                    if (result.error) {
                        alert(result.error.message);
                    }
                });
            },
            (error) => {
                console.log(error);
            });
    }

    protected readonly EMPTY_FAVORITE_LIST = EMPTY_FAVORITE_LIST;
}
